import { render, staticRenderFns } from "./WorkplaceShutdownDialog.vue?vue&type=template&id=228bf52e"
import script from "./WorkplaceShutdownDialog.vue?vue&type=script&lang=ts"
export * from "./WorkplaceShutdownDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports